import { 
  Box,
  Checkbox, 
  FormControl, 
  FormControlLabel, 
  Grid, 
  InputLabel, 
  MenuItem, 
  Paper, 
  Select, 
  Tab, 
  Tabs, 
  TextField, 
  Typography 
} from "@material-ui/core";

const SeccionRegiones = ({ 
  datosPorRegion, 
  tabActual,
  mostrarPestanias,
  onToggleRegion,
  onChangeTab,
  onChangeDatos,
  onChangeUtilidad,
  renderTablaPrecios,
  catalogoUtilidades 
}) => {
  const regionesNormales = datosPorRegion.filter(r => r.idRegion !== 0);
  const regionGlobal = datosPorRegion.find(r => r.idRegion === 0);
  const regionesActivas = datosPorRegion.filter(region => region.activo);

  return (
    <Grid container spacing={2} style={{ padding: '16px', border: '1px solid #eee', borderRadius: '8px', marginTop: '20px' }}>
      <Grid item xs={12}>
        <Typography variant="h6" style={{ marginBottom: '16px' }}>Configuración por Región</Typography>
      </Grid>
      
      {regionesNormales.length === 0 && !regionGlobal ? (
        <Grid item xs={12}>
          <Box mt={2} mb={3} textAlign="center">
            <Typography variant="body1" color="textSecondary">
              ⚠️ No hay regiones configuradas en los circuitos de este paquete
            </Typography>
          </Box>
        </Grid>
      ) : (
        <>
          <Grid item xs={12}>
           <Typography variant="subtitle1">Seleccione regiones:</Typography>
        
            {regionesNormales.map((region, index) => (
              <FormControlLabel
                key={region.idRegion}
                label={region.nombreRegion}
                control={
                  <Checkbox
                    checked={region.activo}
                    onChange={() => onToggleRegion(index)}
                    color="primary"
                  />
                }
              />
            ))}
            
            <FormControlLabel
              label="Global"
              control={
                <Checkbox
                  color="primary"
                  checked={regionGlobal?.activo || false}
                  onChange={() => onToggleRegion(
                    datosPorRegion.findIndex(r => r.idRegion === 0)
                  )}
                />
              }
            />
          </Grid>
                
          <Grid item xs={12}>
            {mostrarPestanias ? (
              <Paper square>
                <Tabs
                  value={tabActual}
                  onChange={onChangeTab}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                {regionesActivas.map((region, index) => (
                    <Tab key={region.idRegion} label={region.nombreRegion} />
                  ))}
                </Tabs>
              </Paper>
            ) : (
              <Typography variant="h6" style={{ padding: '8px 0' }}>
                {regionesActivas[0]?.nombreRegion || 'Seleccione una región'}
              </Typography>
            )}
  
            {regionesActivas.map((region, filteredIndex) => {
              const originalIndex = datosPorRegion.findIndex(r => r.idRegion === region.idRegion);
              
              return (
                <div
                  key={region.idRegion}
                  role="tabpanel"
                  hidden={mostrarPestanias && tabActual !== filteredIndex}
                >
                  <Grid container spacing={2} style={{ padding: '16px 0' }}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label={`Nombre para ${region.nombreRegion}`}
                        value={region.datos.nombre}
                        onChange={(e) => onChangeDatos(
                          originalIndex,
                          'nombre', 
                          e.target.value
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={`Descripción para ${region.nombreRegion}`}
                        value={region.datos.descripcion}
                        onChange={(e) => onChangeDatos(
                          originalIndex,
                          'descripcion', 
                          e.target.value
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="h6">
                        Utilidad para {region.nombreRegion}
                      </Typography>
                      <FormControl fullWidth>
                        <InputLabel>Porcentaje de utilidad</InputLabel>
                        <Select
                          value={region.utilidad}
                          onChange={(e) => onChangeUtilidad(
                            originalIndex,
                            e.target.value
                          )}
                        >
                          {catalogoUtilidades?.map(utilidad => (
                            <MenuItem key={utilidad?.IdCatUtilidad} value={utilidad?.IdCatUtilidad}>
                              {utilidad?.Porcentaje}%
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {renderTablaPrecios(region)}
                    </Grid>
                  </Grid>
                </div>
              );
            })}
          </Grid>
        </>
      )}
    </Grid>
  );
}

  export default SeccionRegiones;